import styled from 'styled-components/macro'

export const StarIcon = styled.img`
  width: 12px;
  margin-left: 5px;
`

export default styled.div`
  font-weight: 100;
  border-radius: 50px;
  padding: 0 7px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #fff;
  height: 24px;
  margin-right: auto;
    
  &.header {
    background-color: rgba(0,0,0,0.4);
  }

  &.active {
    background-color: ${props => props.theme.colors.green};
    color: #fff;
  }

  &.star {
    font-weight: 100;
    font-size: 14px;
    min-width: 65px;
    height: 20px;
    line-height: 20px;
    opacity: 0.8;
    filter: brightness(0.8) invert(1);
  }

  &.inactive {
    background-color: ${props => props.theme.colors.gray[3]};
    color: ${props => props.theme.colors.gray[1]};
    ${StarIcon} {
      filter: brightness(0.6);
    }
  }

  &.button {
    padding: 0 24px 0 16px;
    border-radius: 0;
    background-color: transparent;
    &.active {
      border-right: 1px solid #fff;
    }
    &.inactive {
      border-right: 1px solid #ccc;
    }
  }

  &.home {
    font-size: 16px;
    padding: 0;
    display: flex;
    justify-content: flex-end;
  }
`

export const ScoreText = styled.div`
  padding-top: 3px;
  direction: ltr;
`
